import _defineProperty from "/var/jenkins_home/workspace/tingle.e49e9adf-d3ea-4dee-b9a2-f3d0e4982b89/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
var hasWindow = true;

var ga = function ga() {
  // console.log("GA", ...args);
  if (hasWindow && window.ga) {
    var _window;

    (_window = window).ga.apply(_window, arguments);
  }
};

if (hasWindow && process.env.REACT_APP_GA_TRACKING_ID) {
  /* eslint-disable */
  // prettier-ignore
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
  /* eslint-enable */


  ga('create', process.env.REACT_APP_GA_TRACKING_ID, 'auto');
}

export var setDimension = function setDimension(n, val) {
  ga('set', "dimension".concat(n), val);
};
export var setUserId = function setUserId(partnerId) {
  ga('set', 'userId', partnerId);
};
export var pageView = function pageView() {
  if (hasWindow) {
    // console.log('page view', window.document.location.pathname);
    ga('set', 'page', window.document.location.pathname);
    ga('send', 'pageview');
  }
};
export var sendEvent = function sendEvent(opts) {
  ga('send', _objectSpread(_objectSpread({}, opts), {}, {
    hitType: 'event',
    transport: 'beacon'
  }));
};